<template>
  <div class="main">
    <nav-bar></nav-bar>
    <el-input placeholder="请输入...搜索示例：ssh / 影视" v-model="filterText">
    </el-input>
    <el-tree
      class="filter-tree"
      :data="data"
      :props="defaultProps"
      accordion
      :highlight-current="true"
      :filter-node-method="filterNode"
      ref="tree"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <div v-if="data.url != ''" :class="node.text">
            <a
              :href="data.url"
              :class="data.url ? 'a-link' : ''"
              target="_blank"
              :alt="node.label"
              ><i :class="data.icon"></i> {{ node.label }}</a
            >
          </div>
          <div v-else :class="node.text">
            <i :class="data.icon"></i>
            <!-- {{( node.label + '层级：' + node.level)}} -->
            {{ node.label }}
          </div>
        </span>
      </span>
    </el-tree>  
      
  </div>
</template>

<script>
import NavBar from "@/components/common/navbar/NavBar";
// import itemData from "@/assets/data.json";
import file from "@/assets/yaml/data.yaml";

export default {
  components: { NavBar },
  name: "Index",
  components: {
    NavBar
  },
  data() {
    return {
      filterText: "",
      data: file,
      defaultProps: {
        children: "children",
        label: "label",
        url: "url",
        icon: "icon",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode(value, data, node) {
      node.text = "";
      if (!value) return true;
      const regex = new RegExp(value, "i");
      if (regex.test(data.label)) {
        node.text = "orange";
      }
      return regex.test(data.label);
    },
  },
};
</script>
<style scoped>
.filter-tree {
  color: #000;
}
.orange {
  background-color: rgb(255, 208, 0);
  border-radius: 6px;
  padding: 4px;
}
.orange a {
  color: #000;
}

.el-input{
  margin-bottom: 6px;
}

.custom-tree-node a {
  color: #000;
  text-decoration: none;
}

.el-icon-link,
.a-link {
  color: cornflowerblue !important;
}
.el-icon-notebook-2 {
  color: teal;
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue